<template>
  <div class="page-container" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 轮播图 -->
    <el-carousel trigger="click" height="400px" width="100%" indicator-position="none" arrow="never" :interval="2000">
      <el-carousel-item v-for="(item, index) in adList" :key="index">
        <img :src="imageBaseUrl+item.imgLink" class="banner-image" @click="adClick(item)" />
      </el-carousel-item>
    </el-carousel>
    <!-- 公告栏 -->
    <div class="announcement-container">
      <!-- 公告图标 -->
      <img src="@/assets/newImage/形状@2x.png" class="announcement-icon" />
      <!-- 分隔线 -->
      <div class="divider"></div>
      <!-- 公告内容区域 -->
      <div class="announcement-content">
        <!-- 垂直轮播公告 -->
        <el-carousel height="107px" direction="vertical" indicator-position="none" arrow="never">
          <el-carousel-item v-for="(notice, index) in notices" :key="index">
            <div class="announcement-item"  @click="handleClick(notice, '网站公告')">
              <!-- 公告文本内容 -->
              <div class="announcement-text">
                <div class="announcement-title">{{ notice.title }}</div>
                <div    style="font-size: 14px;color: #00000073; margin-top: 10px;display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">{{notice.content}}</div>
              </div>
              <div style="display: flex; align-items: center;">
                 <!-- 公告日期 -->
               <div style="display: flex;flex-direction: column; align-items: flex-end; height: 100%; ">
                <div class="announcement-date" style="margin-bottom: 17px;">
                <div>{{ notice.createTime }}</div>
              </div>
              <!-- 更多公告链接 -->
              <div class="announcement-more" @click.stop="gotoUser(7)">更多公告
                <span style="color: blue;">></span>
              </div>
               </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 步骤图 -->
    <div class="step-container">
      <procedure></procedure>
    </div>

    <div class="card-container">
      <!-- 顶部导航区域 -->
      <div class="top-section">
        <div class="arrow left"
             :class="{ disabled: isLeftDisabled }"
             @click="scrollTopRow('left')">
          <img style="width: 35px; height: 35px;"
               :src="isLeftDisabled ? require('@/assets/image/arrow-left.png') : require('@/assets/image/arrow-left-2.png')"
               alt="left" />
        </div>

        <div class="top-row" ref="topRow" @scroll="handleScroll">
          <div v-for="(item, index) in categories"
               :key="item.id"
               class="top-card-item"
               @click="setActiveIndex(index)">
            <img :src="imageBaseUrl + item.wapImg" :alt="item.name"   style="width: 60px; height: 60px;">
            <span :class="{ active: index === activeIndex }">{{ item.name }}</span>
            <div v-if="index === activeIndex" class="blue-indicator"></div>
          </div>
        </div>

        <div class="arrow right"
             :class="{ disabled: isRightDisabled }"
             @click="scrollTopRow('right')">
          <img style="width: 35px; height: 35px;"
               :src="isRightDisabled ? require('@/assets/image/youjiantou.png') : require('@/assets/image/youjiantou-2.png')"
               alt="right" />
        </div>
      </div>

      <!-- 添加分割线 -->
      <div class="divider"></div>

      <!-- 底部卡片区域 -->
      <div class="bottom-section">
        <div class="bottom-row">
          <div v-for="(item, index) in visibleBottomItems"
               :key="item.id"
               class="bottom-card-item"
               :class="{ 'card-hover': hoveredIndex === index }"
               @mouseenter="hoveredIndex = index"
               @mouseleave="hoveredIndex = null"
               @click="selectSubCategory(item)">
            <img :src="imageBaseUrl + item.pcImg" :alt="item.name"  style="width: auto;  max-width: 100%; max-height: 100%;">
            <div class="title">{{ item.name }}</div>
            <div class="discount">最高{{ item.maxDiscount }}折</div>
            <div class="button-text" :class="{ 'button-hover': hoveredIndex === index }">
              我有卡要回收
            </div>
          </div>
        </div>

        <!-- 分页指示器 -->
        <div class="pagination">
          <span v-for="n in totalPages"
                :key="n"
                :class="['dot', { active: currentPage === n - 1 }]"
                @click="setPage(n - 1)">
          </span>
        </div>
      </div>
    </div>

    <!-- 服务介绍 -->
    <div class="service-container">
      <div class="service-title">我们竭诚为您服务</div>
      <div  style="width: 48px;height: 7px;background-color: #488eff;margin: 10px 0px"></div>
      <div class="service-image-view">
          <img src="@/assets/newImage/矩形@2x.png" />
          <img src="@/assets/newImage/编组 25备份 2@2x.png" />
          <img src="@/assets/newImage/编组 28@2x.png" />
          <img src="@/assets/newImage/编组 27备份@2x.png" />
      </div>
    </div>
    <!-- 常见问题与卡券学堂 -->
    <div class="faq-container">
      <div class="faq-section">
        <div class="faq-title">
          <img src="@/assets/image/classroom1.png" />
          <div>常见问题</div>
        </div>
        <div class="faq-grid">
          <div class="faq-item" v-for="(faq, index) in questions" :key="index" @mouseenter="highlightItem(index, 0)"
            @mouseleave="unhighlightItem(index, 0)" @click="handleClick(faq, '常见问题')">
            <div class="faq-question">
              <div style="width: 28px;height: 28px;background-color: #4D7EF4;border-radius: 50%; text-align: center; line-height: 28px;color: white;">{{index+1}}</div>
              <div :class="{ 'faq-question-text': true, highlight: faq.highlight }">
                {{ faq.title }}
              </div>
            </div>
            <div class="faq-answer">{{ faq.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="partner-container">
      <div class="partner-title">
        合作伙伴
        <div class="title-indicator"></div>
      </div>
      <div class="partner-list">
        <div class="partner-grid">
          <div class="partner-item"
               v-for="(partner, index) in currentPagePartners"
               :key="index">
            <img :src="partner"  style=" max-width: 100%; height: auto; object-fit: cover;" />
          </div>
        </div>
        <!-- 分页指示器 -->
        <div class="partner-pagination">
          <span v-for="n in totalPartnerPages"
                :key="n"
                :class="['partner-dot', { active: currentPartnerPage === n - 1 }]"
                @click="setPartnerPage(n - 1)">
          </span>
        </div>
      </div>
    </div>
    <floatingSidebar></floatingSidebar>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import floatingSidebar from "../components/base/floating-sidebar.vue";
import procedure from "../components/base/procedure.vue";
import Cokie from "js-cookie";

export default {
  components: {
    floatingSidebar,
    procedure
  },
  data() {
    return {
      adList:[],
      activeIndex: 0,
      currentPage: 0,
      itemsPerPage: 6,
      isLeftDisabled: true,
      isRightDisabled: false,
      hoveredIndex: null,
      fullscreenLoading: false,//加载动画
      imageBaseUrl:'',
      selectedCategoryId: 0,
      notices: [
      ],
      categories: [],
      subCategories: [],
      questions: [],// 场景问题
      partners: [
        require("@/assets/image/img1.webp"),
        require("@/assets/image/img2.webp"),
        require("@/assets/image/img3.webp"),
        require("@/assets/image/img4.webp"),
        require("@/assets/image/img5.webp"),
        require("@/assets/image/img6.webp"),
        require("@/assets/image/img7.webp"),
        require("@/assets/image/img9.webp"),
        require("@/assets/image/img10.webp"),
        require("@/assets/image/img11.webp"),
        require("@/assets/image/img12.webp"),
        require("@/assets/image/img13.webp"),
        require("@/assets/image/img14.webp"),
        require("@/assets/image/img15.webp"),
        require("@/assets/image/img16.webp"),
        require("@/assets/image/img17.webp"),
        require("@/assets/image/img18.webp"),
        require("@/assets/image/img19.webp"),
        require("@/assets/image/img20.webp"),
        require("@/assets/image/img21.webp"),
        require("@/assets/image/img22.webp"),
        require("@/assets/image/img23.webp"),
        require("@/assets/image/img24.webp"),
        require("@/assets/image/img25.webp"),
        require("@/assets/image/img26.webp"),
        require("@/assets/image/img27.webp"),
        require("@/assets/image/img28.webp"),
        require("@/assets/image/img29.webp"),
        require("@/assets/image/img30.webp"),
        require("@/assets/image/img31.webp"),
        require("@/assets/image/img32.webp"),
        require("@/assets/image/img33.webp"),
        require("@/assets/image/img34.webp"),
        require("@/assets/image/img35.webp"),
        require("@/assets/image/img36.webp"),
        require("@/assets/image/img37.jpg"),

      ],
      currentPartnerPage: 0,
      partnersPerPage: 12, // 每页显示 2行6列 = 12个
    };
  },
  mounted() {
    this.getUserInfo()
    this.fetchCategories();
    this.getNoticeList();
    this.questionList();
     this.$nextTick(() => {
      this.handleScroll()
    })
    this.getAd()
  },


  computed: {
    totalPages() {
      return Math.ceil(this.subCategories.length / this.itemsPerPage)
    },
    visibleBottomItems() {
      const start = this.currentPage * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.subCategories.slice(start, end)
    },
    totalPartnerPages() {
      return Math.ceil(this.partners.length / this.partnersPerPage)
    },
    currentPagePartners() {
      const start = this.currentPartnerPage * this.partnersPerPage
      const end = start + this.partnersPerPage
      return this.partners.slice(start, end)
    }
  },
  methods: {
    adClick(item) {
      // 判断是否为http链接
      if(item.jumpLink && (item.jumpLink.startsWith('http://') || item.jumpLink.startsWith('https://'))) {
        this.$router.push({ path: "/webview" ,query: { url: item.jumpLink } });
      }
    },
    getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if(response.code != 200){
          Cokie.remove("token");
          }
        })
        .catch((error) => {
          Cokie.remove("token");
        });
    },

    gotoUser(type){
      this.$store.commit('changedMenuId',type)
      this.$router.push({ path: "/HelpCentre" });
    },
    handleClick(item, type) {
      item.type = type
      window.scrollTo(0, 0);
        this.$router.push({
          path: '/newsdetail',
          query: { news: item, home: true }
        })
      },

    handleScroll() {
      const container = this.$refs.topRow
      this.isLeftDisabled = container.scrollLeft <= 0
      this.isRightDisabled = container.scrollLeft + container.clientWidth >= container.scrollWidth
    },
    scrollTopRow(direction) {
      const container = this.$refs.topRow
      const scrollAmount = container.clientWidth

      if (direction === 'left' && !this.isLeftDisabled) {
        container.scrollLeft -= scrollAmount
      } else if (direction === 'right' && !this.isRightDisabled) {
        container.scrollLeft += scrollAmount
      }
    },
    setPage(pageIndex) {
      this.currentPage = pageIndex
    },
    setActiveIndex(index) {
      this.currentPage = 0;
      this.activeIndex = index
      this.selectedCategoryId = this.categories[index].id
      this.fetchSubCategories(this.categories[index].id)
    },
    handleMouseOver() {
      this.hoveredIndex = true
    },
    handleMouseOut() {
      this.hoveredIndex = false
    },
    // 获取banner
    getAd(){
      http
        .get("/ad/generate/1")
        .then((response) => {
          if (response.code === 200) {
            this.adList = response.data
          }
        })
        .catch(() => {
          this.$message.error("发生意外异常");
        });

    },
    // 获取商品分类
    fetchCategories() {
      http
        .get("/product/type/list")
        .then((response) => {
          if (response.code === 200) {
            this.categories = response.data;
            if (this.categories.length > 0) {
              this.selectedCategoryId = this.categories[0].id;
              this.fetchSubCategories(this.categories[0].id);
            }
          }
        })
        .catch(() => {
          this.$message.error("发生意外异常");
        });
    },
    // 获取子分类
    fetchSubCategories(categoryId) {
      http
        .get(`/product/product/list?prodTypeId=${categoryId}`)
        .then((response) => {
          if (response.code === 200) {
            this.fullscreenLoading = false;
            this.subCategories = response.data;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
          this.$message.error("发生意外异常");
        });
    },
    // 获取公告列表数据
    getNoticeList() {
      http.get("/article/notice/list",{pageSize:3,pageNum:1}).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            item.content = item.content.replace(/<[^>]*>?/g, '');
          });
          response.rows.forEach(item => {
            item.createTime = item.createTime.split(' ')[0];
          });
          this.notices = response.rows;
        }
      })
    },
    // 常见问题
    questionList() {
      http.get("/article/question/list",{pageSize:3,pageNum:1}).then((response) => {
        if (response.code === 200) {
          this.questions = response.rows;
        }
      })
    },


    // 选择分类
    selectCategory(categoryId) {
      this.selectedCategoryId = categoryId;
      this.fetchSubCategories(categoryId);
    },
    // 高亮问题
    highlightItem(index, vl) {
      if (vl == 0) {
        this.faqs[index].highlight = true;
      } else {
        this.lessons[index].highlight = true;
      }
    },
    // 取消高亮
    unhighlightItem(index, vl) {
      if (vl == 0) {
        this.faqs[index].highlight = false;
      } else {
        this.lessons[index].highlight = false;
      }
    },
    //子分类点击事件li
    selectSubCategory(vl) {
      this.$store.commit("changedProdId", vl.prodTypeId);
      this.$store.commit("changedProductId", vl.id);
      this.$router.push("Sales")
      this.$bus.$emit("changedTab", 1);
    },
    setPartnerPage(pageIndex) {
      if (pageIndex >= 0 && pageIndex < this.totalPartnerPages) {
        this.currentPartnerPage = pageIndex
      }
    }
  },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  display: none;
}

.page-container {

  min-height: calc(100vh - 64px - 200px); // 减去header和footer的高度
  display: flex;
  flex-direction: column;

  .banner-image {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    // object-fit: cover;
  }

  .announcement-container {
    position: relative;
    width: 80%;
    //min-width: 1320px;
    margin: 0 auto;
    margin-top: -50px;
    background-color: white;
    z-index: 10;
    border-radius: 10px;
    box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    .announcement-icon {
      width: 110px;
      height: 26px;
    }

    .divider {
      height: 32px;
      width: 2px;
      background-color: #e0e0e0;
      margin: 0 20px;
    }

    .announcement-content {
      flex: 1;

      .announcement-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;

        .announcement-text {
          width: 75%;

          .announcement-title {
            font-size: 16px;
            font-weight: 500;
          }

          .announcement-description {
            margin-top: 10px;
            font-size: 14px;
            color: #00000073;
          }
        }

        .announcement-date {
          font-size: 14px;
          color: #00000073;
        }

        .announcement-more {
          font-size: 16px;
          color: black;
          flex-shrink: 0;
        }
      }
    }
  }

  .step-container {
    margin-top: 50px;
    padding: 0 150px;
    .step-image {
      max-width: 100%; /* 不超过容器的宽度 */
      height: auto;

    }
  }

  .service-container {
    padding: 30px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .service-title {
      font-size: 26px;
      font-weight: 500;
      color: #000000e0;
    }

    .service-image-view {
      height: 447px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      padding: 0px 34px;
      img{
        height: 100%;
      }
    }
  }

  .faq-container {
    background-color: #F2FAFF;
    padding: 20px 69px;
    display: flex;
    padding-bottom: 42px;

    .faq-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      width: 100%;
          margin-top: 10px;
    }

    .faq-item {
      background-color: white;
      border-radius: 10px;
      padding: 15px;
      border: 1px solid transparent;
      transition: all 0.3s ease;

      &:hover {
        border-color: #488eff;
        box-shadow: 0 4px 12px rgba(72, 142, 255, 0.1);


        .faq-question-text {
          color: #4080ff;
          text-decoration: underline;
          text-decoration-color: #488eff;
        }
      }

      .faq-question {
        display: flex;
        align-items: center;

        img {
          width: 36px;
          height: 24px;
        }

        .faq-question-text {
          font-size: 18px;

          margin-left: 10px;
          transition: all 0.3s ease;

          &.highlight {
            color: #488eff;
            text-decoration: underline;
            text-decoration-color: #488eff;
          }
        }
      }

      .faq-answer {
        font-size: 16px;
        color: #00000073;
        margin-top: 10px;
      }
    }

    .faq-section {
      flex: 1;
      margin-right: 20px;

      .faq-title {
        display: flex;
        align-items: center;
        font-size: 26px;
        font-weight: 500;
        padding: 10px 0px;
      }

      .faq-item {

        background-color: white;
        border-radius: 10px;
        // padding: 15px;
      }
    }
  }

  .partner-container {
    background-color: white;
    padding: 40px 0;
    flex-shrink: 0; // 防止内容压缩

    .partner-title {
      font-size: 26px;
      font-weight: 500;
      color: #000000e0;
      text-align: center;
      position: relative;
      margin-bottom: 40px;

      .title-indicator {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 48px;
        height: 7px;
        background-color: #488eff;
        margin: 10px 0px
      }
    }

    .partner-list {
      padding: 0 69px;
    }

    .partner-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(2, 94px); // 指定两行，每行高度94px
      gap: 20px;
      margin-bottom: 20px;

      .partner-item {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.12);
        }

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
    }

    .partner-pagination {
      display: flex;
      justify-content: center;
      gap: 4px;
      margin-top: 20px;
    }

    .partner-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ddd;
      cursor: pointer;
      transition: all 0.3s;

      &.active {
        width: 25px;
        border-radius: 4px;
        background: #488eff;
      }

      &:hover {
        background: #488eff;
      }
    }
  }
}
.card-container {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  padding: 30px 0;
  margin: 20px 0;
  background-color: #F2FAFF;

  .top-section {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0 auto;
    max-width: 1440px;
    width: 90%;
  }

  .top-row {
    display: flex;
    width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
    padding: 0 40px;
  }

  .arrow.left {
    left: 0;
  }

  .arrow.right {
    right: 0;
  }

  .bottom-section {
    max-width: 1440px;
    width: 90%;
    margin: 0 auto;
    padding: 20px 0;
  }

  .bottom-row {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: #eee;
    // margin: 10px 0;
  }
}

.top-card-item {
  position: relative;
  flex: 0 0 12.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.top-card-item img {
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
}

.top-card-item span {
  font-size: 16px;
  color: #333;
}

.top-card-item span.active {
  color: #4080ff;
  font-weight: 500;
}

.arrow {
  position: absolute;
  width: 35px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
  transition: all 0.3s;

  img {
    width: 16px;
    height: 16px;
  }

  &.disabled {
    cursor: not-allowed;
  }
}

.bottom-card-item {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 30px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s;
}

.card-hover {
  border-color: #4080ff;
  box-shadow: 0 2px 12px rgba(64, 128, 255, 0.1);
}

.bottom-card-item:hover {
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.bottom-card-item img {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}

.bottom-card-item .title {
  font-size: 16px;
  color: #333;
  margin: 15px 0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}

.discount {
  font-size: 14px;
  color: #ff4d4f;
  margin-bottom: 15px;
}

.button-text {
  width: 90%;
  padding: 12px 0;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 6px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.button-hover {
  background: #4080ff;
  color: white;
  border-color: #4080ff;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 15px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
  transition: all 0.3s;
}

.dot.active {
  width: 25px;
  border-radius: 4px;
  background: #4080ff;
}

/* 修改蓝色下标样式 */
.blue-indicator {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 5px;
  background-color: #4080ff;
  border-radius: 3px;
}
</style>
